// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__202yB","productName":"Table_productName__3VJvr"};